import {useStoresStore} from '~/stores/store'

export default defineNuxtPlugin(async (nuxtApp) => {
  // 서버사이드에서만 실행
  if (import.meta.server) {
    const route = useRoute()
    const event = useRequestEvent()
    const subdomain = event?.context?.subdomain
    const storesStore = useStoresStore()
    const appStore = useAppStore()

    if (subdomain && !storesStore.hasStore(subdomain as string)) {
      try {
        const store = await useStoreValidation(subdomain as string)
        const {client} = useApolloClient()
        const {data, error} = await client.query({
          query: StoreValidationQueryDocument,
          variables: {slug: subdomain},
          context: {
            // fetchOptions: { signal: AbortSignal.timeout(10_000) },
          },
        })

        if (error) {
          console.error('store load error', error)
          throw error
        }

        if (!data?.storeBySlug) {
          throw new Error('Store not found.')
        }

        console.debug('store load success')

        storesStore.setStore(store)
        //appStore.setCurrentStore(slug as string, store)
      } catch (error) {
        // 에러 처리
        console.error('store load error', error)
      }
    }
  }
})
